import React, {memo} from 'react';
import {i_chat_sort} from "../../../icons";
import {InputRadioFilter} from "../../../utils/radio/InputRadioFilter";

function ChatListSort({sort, handleChange}) {

  return <div className="sidebar-chat__dropdown">
    <button type="button" className="sidebar-chat__icon">
      {i_chat_sort()}
    </button>
    <ul className="dropdown">
      <li className="dropdown__item">
        <InputRadioFilter value="new" checked={sort === "new"} text="Сначала новые" count="" name="sort" onChange={handleChange}/>
      </li>
      <li className="dropdown__item">
        <InputRadioFilter value="old" checked={sort === "old"} text="Сначала старые" count="" name="sort" onChange={handleChange}/>
      </li>
    </ul>
  </div>;
}

export default memo(ChatListSort, (prevProps, nextProps) => {
  return prevProps.sort === nextProps.sort
});